import type { UiMessages } from "../types";

export const en: UiMessages = {
  nav: {
    streams: "Streams",
    videos: "Videos",
    shorts: "Shorts",
    forYou: "For you",
    vr: "VR",
    cartoon: "Cartoon",
    hentai: "Hentai",
    sections: "More",
    menu: "Menu",
    game: "Sex Game",
    stories: "Sex Stories",
    escorts: "Escorts",
    ai: "AI Girlfriends",
    paysites: "Premium sites",
    home: "Home",
    following: "Following",
    watching: "Watching",
    rankings: "Rankings",
    invite: "Invite friends",
    coins: "Sweet Coin",
    achievements: "Achievements",
    hot: "Hot now",
    random: "Random video",
    saved: "Saved",
    reacted: "Reacted",
    boost: "Sweet Boost",
    premium: "Premium",
    stars: "Pornstars",
    productions: "Studios",
    categories: "Categories",
    telegram: "Telegram channel",
    allSections: "All sections",
    mainNavigation: "Main navigation",
    quickNavigation: "Quick navigation",
    show: "Show",
    coinsReady: "Sweet Coins ready to collect",
    logIn: "Log in",
    search: "Search",
    closeSearch: "Close search",
    language: "Language",
    theme: "Theme",
    themeDark: "Dark",
    themeLight: "Light",
  },
  age: {
    parents: "Parents: our {link} page explains how to block access to this site. Sweet is labelled with the RTA label.",
    parentalControls: "parental controls",
    title: "This is an adult website",
    body: "This website contains age-restricted materials including nudity and explicit depictions of sexual activity. By entering, you confirm that you are at least 18 years old, or the age of majority in the jurisdiction you are accessing the website from, and that you consent to viewing sexually explicit content.",
    enter: "I am 18 or older — Enter",
    exit: "I am under 18 — Exit",
  },
  consent: {
    title: "Cookies",
    body: "Sweet is free thanks to ads. Our advertising partners use cookies to show them and to count their views and clicks. Necessary storage, like your age confirmation, works either way.",
    privacy: "Privacy Policy",
    acceptAll: "Accept all",
    onlyNecessary: "Only necessary",
    settings: "Cookie settings",
  },
  ago: { now: "now", m: "{n}m", h: "{n}h", d: "{n}d", w: "{n}w", mo: "{n}mo", y: "{n}y" },
  cams: {
    allPlatforms: "All platforms",
    watchOnSite: "Watch on {site}",
    liveFor: "live {time}",
    tryAnother: "Try another tag or region, or check back in a little while.",
    nobodyLiveOn: "Nobody is live on {name} right now",
    platformShowUpHint: "{name} streams show up here the moment they start. Check back in a little while.",
    liveNowCount: "{n} live now",
    opensOn: "they open on {site}",
    streamerSite: "the streamer’s site",
    orWatch: "Or watch {link}.",
    videoTag: "#{tag} videos",
    liveStreams: "Live streams",
    platformStreams: "{name} live streams",
    liveCams: "Live cams",
    platformCams: "{name} cams",
    moreLiveCams: "More live cams",
    byTopic: "Live cams by topic",
    breadcrumb: "Breadcrumb",
    live: "Live",
    viewers: "Viewers:",
    isLive: "{name} is live",
    watchOn: "{title} — watch live on {site}",
    nobodyLive: "Nobody is live right now",
    noMatch: "No live streams match these filters",
    showUpHint: "Streams show up here the moment they start. Check back in a little while.",
    clearFilters: "Clear filters",
    clearAll: "Clear all",
    clear: "Clear",
    seeAllPlatforms: "See all platforms",
    watchVideos: "Watch videos",
    onPlatform: " on {name}",
    newOnTelegram: "New live cams on Telegram",
    loadMoreFailed: "Couldn’t load more — try again",
    platforms: "Platforms",
    streamPlatforms: "Stream platforms",
    platformsAndFilters: "Stream platforms and filters",
    categories: "Categories",
    all: "All",
    region: "Region",
    allRegions: "All regions",
    more: "More",
    newModels: "New models",
    tags: "Tags",
    removeTag: "Remove tag",
    remove: "Remove",
    loading: "Loading",
    offline: "Offline",
    seeAll: "See all",
    genders: { female: "Women", male: "Men", couple: "Couples", trans: "Trans" },
    regions: { north_america: "North American", south_america: "South American", europe: "European & Russian", asia: "Asian", other: "Other regions" },
  },
  video: {
    fullScene: "Watch the full scene on {site}",
    upNext: "Up next",
    nextPage: "Next page",
    moreVideos: "More videos",
    end: "You’ve reached the end.",
    loadMoreFailed: "Couldn’t load more — try again",
    likes: "Likes",
    premiumVideo: "Premium video",
    subscribeToWatch: "Subscribe to watch this video in full.",
    getPremium: "Get Premium",
    logIn: "Log in",
    playsIn: "Plays in {name}'s player",
    partnerBlocked: "The video plays from {name}'s servers, and they aren't reachable from your network: {name} may be blocked by your internet provider or in your country.",
    unavailable: "{name} doesn't play its videos in your country, so this one can't be watched here.",
    watchCams: "Watch live cams instead",
    chatLive: "Chat live with {name} on {site}",
    play: "Play {title}",
    sponsored: "Sponsored",
    onlyfansCreators: "OnlyFans creators",
    liveNowFree: "Live now · free",
    allVideos: "All videos",
    stoppedAt: "Stopped at {at} of {of}",
    watchedToEnd: "Watched to the end",
  },
  profile: { followers: "Followers", views: "Views", videos: "Videos", verified: "Verified", follow: "Follow", unfollow: "Unfollow" },
  lists: {
    categories: "Categories",
    popular: "Popular",
    aToZ: "A – Z",
    jumpToLetter: "Jump to letter",
    allCategories: "All categories",
    noVideosYet: "No videos here yet",
    pageN: "Page {n}",
    newEveryDay: "New videos are added every day.",
    videoCount: "{n} videos",
    pornstars: "Pornstars",
    pornstarsIntro: "The most followed creators this week.",
    studios: "Porn Studios",
    studiosIntro: "Production companies and channels, ranked by followers.",
    noVideosWithTag: "No videos with this tag",
    showAllVideos: "Show all videos",
  },
  hot: {
    title: "Hot now",
    intro: "The videos watched most on Sweet in the last hours.",
  },
  comments: {
    title: "Comments",
    placeholder: "Add a comment…",
    post: "Post",
    login: "Log in to comment",
    coinsHint: "+{n} coins for each of your first {max} comments a day",
    earned: "+{n} coins",
    empty: "No comments yet. Be the first.",
    more: "Show more",
    delete: "Delete",
    short: "Write a little more.",
    long: "That's too long: {n} characters at most.",
    links: "Links and contacts aren't allowed in comments.",
    forbidden: "This comment can't be posted.",
    rate: "You're commenting too fast. Try again later.",
    duplicate: "You've already posted this.",
    failed: "Couldn't post it. Try again.",
    like: "Like",
    dislike: "Dislike",
    rateLogin: "Log in to rate videos",
    liked: "{p}% liked",
  },
  starVote: {
    title: "Star of the month",
    vote: "Vote",
    voteFor: "Vote for {name} as star of the month",
    voteAgain: "Vote again · {n} coins",
    confirm: "Spend {n} coins?",
    standing: "#{rank} this month · votes: {n}",
    noVotes: "No votes yet this month",
    thanks: "Thanks for your vote!",
    paidThanks: "Vote counted · −{n} coins",
    coins: "Not enough coins: a vote costs {n}.",
    limit: "That's all your votes for today.",
    rules: "One free vote a day, then {n} coins a vote.",
    boardIntro: "Members vote for their favourite stars on the stars' pages: one free vote a day, more for {n} coins each.",
    boardEmpty: "No votes yet this month. Vote for a star on their page.",
    votes: "Votes",
    lastWinner: "Last month's star",
    login: "Log in to vote",
  },
  achievements: {
    title: "Achievements",
    intro: "Unlock achievements as you watch, follow and take part. Each one gives Sweet Coins.",
    unlocked: "Unlocked",
    coins: "+{n} coins",
    progress: "{x} of {n}",
    total: "{x} of {n} unlocked",
    login: "Log in to collect achievements and their coins.",
    signup: "Create account",
    toast: "Achievement unlocked",
    names: {
      "videos-1": ["First video", "Watch your first video"],
      "videos-10": ["Warming up", "Watch 10 videos"],
      "videos-100": ["Regular", "Watch 100 videos"],
      "videos-1000": ["Connoisseur", "Watch 1,000 videos"],
      "hours-1": ["One hour in", "Watch for an hour"],
      "hours-10": ["Ten hours", "Watch for 10 hours"],
      "hours-100": ["Marathon", "Watch for 100 hours"],
      "streak-3": ["Three in a row", "Watch on 3 days in a row"],
      "streak-7": ["Week streak", "Watch every day for a week"],
      "streak-30": ["Month streak", "Watch every day for 30 days"],
      "follows-5": ["Fan", "Follow 5 stars or studios"],
      "likes-25": ["Big heart", "Like 25 videos"],
      "saves-10": ["Collector", "Save 10 videos"],
      "days-7": ["Coin week", "Collect coins on 7 days"],
      "days-30": ["Coin month", "Collect coins on 30 days"],
      "invites-1": ["Bring a friend", "Invite a friend who signs up"],
      "comments-1": ["First words", "Write your first comment"],
      "comments-25": ["Talkative", "Write 25 comments"],
      "votes-1": ["Voter", "Vote for a star of the month"],
    },
  },
  pwa: {
    appName: "Sweet app",
    bannerLabel: "Install the app",
    bannerPitch: "Full screen, no app store",
    install: "Install",
    notNow: "Not now",
    installApp: "Install the app",
    howToInstall: "How to install",
    inApp: "You're using the app.",
    cardPitch: "Full screen, one tap from your Home Screen. No app store needed.",
    manual: "Open the browser menu and choose {install} or {add}.",
    iosTitle: "Add Sweet to your Home Screen",
    iosShare: "Tap {share} in the browser bar (on iOS 26: {more}, then {share})",
    iosAdd: "Choose {add}",
    iosConfirm: "Tap {confirm}: Sweet opens full screen from your Home Screen",
    share: "Share",
    more: "•••",
    add: "Add to Home Screen",
    confirm: "Add",
    installMenu: "Install app",
    gotIt: "Got it",
    close: "Close",
    offlineTitle: "You're offline",
    offlineBody: "Sweet needs the internet to play videos and cams. Check your connection and try again.",
    retry: "Try again",
    recent: "Opened recently",
  },
  notifications: {
    title: "Notifications",
    empty: "Nothing new yet. Follow stars and studios, or add cam models to your favourites, and their news shows up here.",
    newVideos: "New videos",
    liveNow: "Live now",
    markRead: "Mark all as read",
    pushOn: "Turn on notifications",
    pushOff: "Turn off notifications",
    pushHint: "Hear about new videos and live favourites even with Sweet closed.",
    pushBlocked: "Notifications are blocked for Sweet in your browser's settings.",
    pushUnsupported: "This browser can't show notifications. On iPhone, add Sweet to your home screen first.",
    pushEnabled: "Notifications are on",
    favorites: "Favourite models",
    addFavorite: "Add to favourites",
    removeFavorite: "Remove from favourites",
    favoritesEmpty: "No favourite models yet. Tap the heart on a cam to add one.",
    offline: "Offline",
    viewAll: "See all",
  },
  forYou: {
    title: "For you",
    all: "All",
    continueWatching: "Continue watching",
    intro: "Picked from what you like, save, watch and follow.",
    empty: "Like, save or follow a few videos and stars, and this fills with videos picked for you.",
    more: "More",
  },
  shorts: {
    straight: "Straight",
    gay: "Gay",
    trans: "Trans",
    watchFull: "Watch full video",
    like: "Like",
    liked: "Liked",
    save: "Save",
    saved: "Saved",
    share: "Share",
    copied: "Link copied",
    soundOn: "Turn sound on",
    soundOff: "Turn sound off",
    tapForSound: "Tap for sound",
    report: "Report",
    follow: "Follow",
    following: "Following",
    previous: "Previous",
    next: "Next",
    close: "Close",
    end: "That's all for now. More in Videos.",
    empty: "No shorts here yet.",
    live: "Live",
    watchLive: "Watch live free",
    watching: "{n} watching",
    profile: "Profile",
    moreLive: "More live cams",
  },
  search: {
    searches: "Searches",
    popular: "Popular searches",
    categories: "Categories",
    searchFor: "Search videos for “{q}”",
    nothingFor: "Nothing found for “{q}”.",
    title: "Search Sweet",
    placeholder: "Search videos, people and brands",
    hint: "Find videos, stars, productions and categories. Press / anywhere to start typing.",
    stars: "Stars",
    productions: "Productions",
    other: "Other",
    otherProfiles: "Other profiles",
    nothing: "Nothing found",
    tryAgain: "Check the spelling or try a broader term.",
    backHome: "Back to home",
  },
  notFound: { title: "This page doesn’t exist", body: "The video may have been removed, or the link is mistyped.", home: "Go to home" },
  common: {
    close: "Close",
    copy: "Copy",
    copied: "Copied",
    more: "More",
    loading: "Loading",
    clearAll: "Clear all",
    browseVideos: "Browse videos",
    scrollLeft: "Scroll left",
    scrollRight: "Scroll right",
  },
  actions: {
    react: "React",
    reacted: "Reacted",
    save: "Save",
    saved: "Saved",
    follow: "Follow",
    following: "Following",
    followName: "Follow {name}",
    unfollowName: "Unfollow {name}",
    moreOptions: "More options",
    share: "Share",
    copyLink: "Copy link",
    linkCopied: "Link copied",
    report: "Report",
    home: "Sweet — home",
    onSweet: "{name} on Sweet",
    joinMe: "Join me on Sweet",
    inviteLink: "Your invite link",
  },
  library: {
    savedEmpty: "Nothing saved yet",
    savedHint: "Tap the bookmark under any video to keep it here. Your list is stored on this device only.",
    reactedEmpty: "No reactions yet",
    reactedHint: "Videos you heart show up here, newest first.",
    watchingEmpty: "Nothing watched yet",
    watchingHint: "Videos you play show up here with the exact moment you stopped, and pick up from there when you open them again.",
    removeWatching: "Remove from Watching",
    removeVideo: "Remove {title} from Watching",
    followingEmpty: "You’re not following anyone yet",
    followingHint: "Tap the + on a creator or studio and their newest videos will collect here. Follows are stored on this device only.",
    discoverModels: "Discover models",
    noVideosHint: "Try another category — new videos are added every day.",
    backToAll: "Back to all videos",
  },
  player: {
    resumesAt: "Resumes at {at}",
    startOver: "Start over",
    unavailable: "This video is not available right now.",
    play: "Play",
    pause: "Pause",
    seek: "Seek",
    back10: "Back 10 seconds",
    forward10: "Forward 10 seconds",
    mute: "Mute",
    unmute: "Unmute",
    volume: "Volume",
    settings: "Settings",
    pip: "Picture in picture",
    fullscreen: "Full screen",
    exitFullscreen: "Exit full screen",
    quality: "Quality",
    speed: "Playback speed",
    normal: "Normal",
    auto: "Auto",
    partner: "the partner",
  },
  ads: { ad: "Ad", advertisement: "Advertisement", muteAd: "Mute ad", unmuteAd: "Unmute ad", skipIn: "Skip in {n}", skipAd: "Skip ad ›" },
  auth: {
    username: "Username",
    usernameOrEmail: "Username or email",
    emailOptional: "Email (optional)",
    password: "Password",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    confirmNewPassword: "Confirm new password",
    showPassword: "Show password",
    hidePassword: "Hide password",
    forgot: "Forgot password?",
    remember: "Keep me signed in",
    logIn: "Log in",
    createAccount: "Create account",
    usernameHelp: "3–24 letters, numbers, dots or underscores. Shown on Rankings.",
    emailHelp: "Only used to reset your password. You can add it later in your account.",
    passwordHelp: "At least 8 characters.",
    adult: "I am 18 years or older.",
    agree: "I agree to the {terms} and {privacy}.",
    terms: "Terms",
    privacy: "Privacy Policy",
    savePhrasesTitle: "Save your recovery phrases",
    savePhrasesBody: "You signed up without an email, so these phrases are how you get back in if you forget your password.",
    continue: "Continue",
    resetHow: "How to reset your password",
    byEmail: "Email me a link",
    byPhrase: "Use a recovery phrase",
    phraseIntro: "For accounts made without an email: enter your username and any one of the recovery phrases you saved when you signed up.",
    phrase: "Recovery phrase",
    phrasePlaceholder: "word word word word",
    phraseHelp: "The 4 words of one phrase. Each phrase works once.",
    saveNewPassword: "Save new password",
    sendLink: "Send reset link",
  },
  phrases: {
    warning: "Save these now: they won’t be shown again. If you forget your password, your username and any one of these phrases let you choose a new one. Each phrase works once. Keep them private.",
    list: "Your recovery phrases",
    copyAll: "Copy all",
    download: "Download .txt",
    savedCheck: "I’ve saved my recovery phrases somewhere safe.",
    done: "Done",
    fileTitle: "Sweet recovery phrases for @{username}",
    fileHow: "If you forget your password, go to {url}, choose “{option}” and enter your username and any one of these phrases.",
    filePrivate: "Each phrase works once. Keep them private: anyone with your username and one of these phrases can take over your account.",
    none: "Your account has no email and no recovery phrases. If you forget your password, you won’t be able to get back in. Make recovery phrases now.",
    optional: "Recovery phrases let you choose a new password without email. Optional while your account has an email.",
    left: "{left} of {total} phrases unused.",
    leftMade: "{left} of {total} phrases unused, made {date}.",
    how: "Each one, with your username, lets you choose a new password once. Lost them? Make new ones and the old ones stop working.",
    make: "Make recovery phrases",
    makeNew: "Make new phrases",
  },
  account: {
    menu: "Account menu",
    settings: "Account settings",
    profiles: "Your profiles",
    logOut: "Log out",
    uploadPhoto: "Upload photo",
    removePhoto: "Remove current photo",
    displayName: "Display name",
    showInRankings: "Show me on Rankings",
    rankingsHelp: "Your name, photo and watch statistics appear on the public {link}. Turn this off to be left out; your time is still counted.",
    save: "Save",
    emailHelp: "Only used to send you a link if you forget your password. Leave it empty to remove it.",
    saveEmail: "Save email",
    changePassword: "Change password",
    deleteWarning: "This permanently deletes your account, saved videos, reactions and follows. It can’t be undone.",
    typeToConfirm: "Type {word} to confirm",
    deleteMine: "Delete my account",
  },
  pay: {
    billingPeriod: "Billing period",
    monthly: "Monthly",
    yearly: "Yearly",
    yourPlan: "Your plan",
    month: "month",
    year: "year",
    oneMonth: "1 month",
    months: "{n} months",
    oneYear: "1 year",
    years: "{n} years",
    perMonth: "{price} a month",
    save: "Save {n}%",
    comingSoon: "Coming soon",
    reward: "−{n}% your reward",
    plays: "{n} Sweet Room plays",
    addedAtOnce: "Added at once",
    get: "Get {plan}",
    addMonth: "Add a month",
    addYear: "Add a year",
    opensSoon: "Payments open soon",
    alreadyMember: "Already a member?",
    choose: "Choose how to pay",
    payWith: "Pay with",
    starsInBot: "{n} Stars in our Telegram bot",
    card: "Card",
    crypto: "Crypto",
    cryptoMore: "BTC, USDT, ETH, TON and 30+ more",
    tooManyStars: "Too much for one Telegram Stars payment.",
    cardMin: "Card payments start at {price}.",
    payStars: "Pay with Telegram Stars",
    preparing: "Preparing your checkout…",
    loginFirst: "Log in first",
    cantStart: "Can’t start checkout",
    noAdsCoins: "No ads + {n} Sweet Coins",
    addedOnPay: "Added to your balance as soon as you pay",
    payInTelegram: "Pay in Telegram",
    waitingStars: "Waiting for your payment — this page updates by itself",
    allSet: "You’re all set!",
    noAds: "No ads.",
    noAdsUntil: "No ads until {date}.",
    coinsAdded: "{n} coins are in your balance.",
    startWatching: "Start watching",
    great: "Great",
    payCard: "Pay by card",
    failedTitle: "The payment didn’t go through",
    failedBody: "Nothing was charged. You can try again.",
    newTab: "Pay in the new tab",
    newTabBody: "Card, Apple Pay or Google Pay, on Chain2Pay’s secure page. This page updates by itself once it’s paid.",
    waiting: "Waiting for your payment…",
    openAgain: "Open the payment page again",
    somethingWrong: "Something went wrong. Try again in a minute.",
    offline: "You seem to be offline. Try again in a minute.",
    bestValue: "Best value",
    coins: "coins",
    orStars: "or {n} Stars",
    packsSoon: "Coin packs go on sale very soon.",
    nCoins: "{n} Sweet Coins",
    collected: "+{n} Sweet Coins collected!",
    collectedToday: "Collected today",
    nextBonus: "Next bonus in",
    collecting: "Collecting…",
    collect: "Collect {n} Sweet Coins",
    alreadyCollected: "You’ve already collected today’s coins. Come back tomorrow.",
    offerLabel: "Sweet Coins and Premium",
    offerTitle: "Get Sweet Coins",
    offerFor: "For Sweet Room and paid videos",
    premiumFrom: "Premium from {price}",
    upTo: "No ads + up to {n} coins",
    packsFrom: "Coin packs from {price}",
    collectFree: "Or collect free coins every day",
    offerButton: "Sweet Coins offer",
    guestCollected: "+{n} Sweet Coins! If you don’t want to lose your coins, sign up on Sweet.",
    guestKeep: "Without an account, coins are kept for {days} days and then lost.",
    guestSignup: "Sign up free and keep them",
    guestLogin: "Have an account? Log in",
    guestExpire: "{n} coins will be lost on {date}.",
    guestUnsaved: "Your coins aren’t saved yet: sign up to keep them",
    guestExpiring: "{n} of your Sweet Coins will be lost in less than a day. Sign up free to keep them.",
  },
  footer: {
    copyright: "Copyright",
    takedown: "Takedown",
    contact: "Contact",
    creators: "Creators",
    claim: "Claim your profile",
    webmasters: "Webmasters",
    terms: "Terms",
    privacy: "Privacy",
    info: "Site information",
    telegram: "{site} on Telegram",
  },
  report: {
    heading: "Report a video",
    reason: "Reason",
    takedown: "Copyright / DMCA",
    abuse: "I appear in this video without consent",
    minor: "Someone in this video may be under 18",
    other: "Something else",
    url: "Video link or ID",
    email: "Your email",
    details: "Details",
    detailsPlaceholder: "What should we remove and why?",
    send: "Send report",
  },
};
